import axiosInstance from '../../../api/axiosConfig';
import {
  MonitoredUrl,
  AddMonitoredUrl,
  UpdateMonitoredUrl,
  MonitoringStats,
} from '../types/site-monitor';

export const getMonitoredUrls = async (): Promise<MonitoredUrl[]> => {
  const response = await axiosInstance.get<MonitoredUrl[]>('/site-monitor');
  return response?.data;
};

export const getMonitoringStats = async (): Promise<MonitoringStats> => {
  const response = await axiosInstance.get<MonitoringStats>('/site-monitor/stats');
  return response?.data;
};

export const getMonitoredUrl = async (id: number): Promise<MonitoredUrl> => {
  const response = await axiosInstance.get<MonitoredUrl>(`/site-monitor/${id}`);
  return response?.data;
};

export const getUrlHistory = async (
  id: number,
  params?: { checkType?: string; from?: string; to?: string; page?: number; limit?: number },
) => {
  const response = await axiosInstance.get(`/site-monitor/${id}/history`, { params });
  return response?.data;
};

export const createMonitoredUrl = async (data: AddMonitoredUrl): Promise<MonitoredUrl> => {
  const response = await axiosInstance.post<MonitoredUrl>('/site-monitor', data);
  return response?.data;
};

export const updateMonitoredUrl = async (
  id: number,
  data: UpdateMonitoredUrl,
): Promise<MonitoredUrl> => {
  const response = await axiosInstance.patch<MonitoredUrl>(`/site-monitor/${id}`, data);
  return response?.data;
};

export const deleteMonitoredUrl = async (id: number): Promise<void> => {
  await axiosInstance.delete(`/site-monitor/${id}`);
};

export const getAlerts = async (page = 1, limit = 10) => {
  const response = await axiosInstance.get('/site-monitor/alerts', {
    params: { page, limit },
  });
  return response?.data;
};
